module.exports = __webpack_public_path__ + "static/media/u21a-c_a3.d63f67a6.mp3";